import { Box, CssBaseline, Toolbar } from '@mui/material';
import React, { useState } from 'react';
import { MainListItems } from '../../components/Navbar/listItems';
import NewNavbar from '../../components/Navbar/New/Navbar';
import Sidebar from '../../components/Navbar/Sidebar';
import theme from '../../mui-theme';
import { useUser } from '../../context/UserContext';

const AdminDashboardLayout = ({ children }) => {
  const isMobile = window.innerWidth < 768;
  const drawerWidth = 240;
  const [open, setOpen] = useState(!isMobile);
  const { role } = useUser();

  if (role !== 'super-admin') {
    window.location.href = '/unauthorized';
  }

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  return (
    <Box display="flex">
      <CssBaseline />
      <NewNavbar />
      <Sidebar
        theme={theme}
        MainListItems={MainListItems}
        open={open}
        toggleDrawer={toggleDrawer}
        type="admin-dashboard"
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          padding: '16px',
          ml: open ? `${drawerWidth}px` : 7,
        }}>
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: '16px' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default AdminDashboardLayout;
